import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchLocationLink } from 'redux/location-links/actions';

import CommonLinkCheckbox from 'components/common/link-elements/CommonLinkCheckbox';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './LocationLinkOptions.css';


function LocationLinkOptions(props) {
  const { me, linkItem, patchLocationLink } = props;
  const { t } = useTranslation();
  const locked = me && me.subscription && !me.subscription.ff_maps;
  const placeholderContent = (
    <div>{t("This option is available on the PRO plan.")}</div>
  );

  return (
    <div className="location-link-options__component">
      <ProFeaturePlaceholder
        noKeyIcon
        locked={locked}
        placeholderContent={placeholderContent}
      >
        <CommonLinkCheckbox
          proLabel
          label={t("Map is Expanded")}
          key={`location-link-is-expanded-checkbox-key-${linkItem.id}`}
          linkId={linkItem.id}
          initialValue={linkItem.is_expanded}
          parameter="is_expanded"
          patchFunction={patchLocationLink}
          disabled={locked}
        />
      </ProFeaturePlaceholder>

      <ProFeaturePlaceholder
        noKeyIcon
        locked={locked}
        placeholderContent={placeholderContent}
      >
        <CommonLinkCheckbox
          proLabel
          label={t("Map is Hidden")}
          key={`location-link-is-hidden-checkbox-key-${linkItem.id}`}
          linkId={linkItem.id}
          initialValue={linkItem.is_hidden}
          parameter="is_hidden"
          patchFunction={patchLocationLink}
          disabled={locked}
        />
      </ProFeaturePlaceholder>

      <ProFeaturePlaceholder
        noKeyIcon
        locked={locked}
        placeholderContent={placeholderContent}
      >
        <CommonLinkCheckbox
          proLabel
          label={t("Map is Locked")}
          key={`location-link-is-locked-checkbox-key-${linkItem.id}`}
          linkId={linkItem.id}
          initialValue={linkItem.is_locked}
          parameter="is_locked"
          patchFunction={patchLocationLink}
          disabled={locked}
        />
      </ProFeaturePlaceholder>
    </div>
  );
}

LocationLinkOptions.propTypes = {
  patchLocationLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  me: PropTypes.object,
};

LocationLinkOptions.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLocationLink,
  },
)(LocationLinkOptions);
